module.exports = __webpack_public_path__ + "img/Malaysia1.50dd32ff.png";